export default "__VITE_ASSET__f93695ab__"